import { render } from "./Muhurtha.vue?vue&type=template&id=3235bfc2&scoped=true"
import script from "./Muhurtha.vue?vue&type=script&lang=js"
export * from "./Muhurtha.vue?vue&type=script&lang=js"

import "./Muhurtha.vue?vue&type=style&index=0&id=3235bfc2&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3235bfc2"]])

export default __exports__